var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('ttbox-netatmo'),_vm._l((_vm.interfaces),function(inter){return _c('ttbox-interface',{key:inter.idInterface,attrs:{"ttInterface":inter}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }